


import watchNewColheita from './saga/new';
import watchFindColheita from './saga/find';
import watchCreateColheita from './saga/create';
import watchListColheita from './saga/listTable';
import watchDeleteColheita from './saga/delete';
import watchNewFilterColheita from './saga/newFilter';
import watchNewFilterNextPageColheita from './saga/newFilterNextPage';
import watchRelatorioColheita from './saga/relatorioColheita';

export const colheitaSaga = [
    watchNewColheita(),
    watchFindColheita(),
    watchCreateColheita(),
    watchListColheita(),
    watchDeleteColheita(),
    watchNewFilterColheita(),
    watchNewFilterNextPageColheita(),
    watchRelatorioColheita(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';
